import React, { useEffect, useState } from "react";
import axios from "axios";
import RedeemRewardsModal from "../WINCentive/RedeemRewardsModal";
import "./WinRewardsHistory.css";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const WinRewardsHistory = () => {
    const navigate = useNavigate();
  const [rewardsData, setRewardsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state
  const [email, setEmail] = useState(""); // User's email
  const [amount, setAmount] = useState(""); // Redemption amount (no default value)
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const { t } = useTranslation();
  const contractData = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const fetchRewardsHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        Endpoints.GetWINRewardsHistoryDetails,
        `_Params=${encodeURIComponent(
          JSON.stringify({
            MemberID: contractData.userData.MemberID,
            Contract: contractData.userData.ContractIdentified,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            EmailID: contractData.userData.EmailID
          })
        )}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRewardsData(response.data);
    //    setEmail(contractData.userData.EmailID); // Set the user's email here
    } catch (err) {
      setError("Failed to fetch rewards history.");
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
    fetchRewardsHistory();
  }, []);

   
  const handleRewardHistoryClick = () => {
    navigate("/incentive-rewardshistory");
  };

  const handleAchievementsClick = () => {
    navigate("/incentive-achievementdetails");
  };

  const handleMyWinCardClick = () => {
    navigate("/pay-cards");
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const { Balance, Total, Redeemed, WINRewardsHistory } = rewardsData || {};
  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
     <ToastContainer />
      <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
       <button className="win-back-btn me-3" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">My WINRewards History</h2>
      </div>
      <div className="col-md-12 col-lg-6 mt-4 d-flex justify-content-end flex-sm-column flex-md-row flex-wrap align-items-center gap-1">
        <button className="win-btn-with-icon reward-history-btn" onClick={handleRewardHistoryClick}>
          {t("REWARD HISTORY")}
        </button>
        <button className="win-btn-with-icon achievements-btn ms-3" onClick={handleAchievementsClick}>
          {t("ACHIEVEMENTS")}
        </button>
        <button className="win-btn-with-icon mywincard-btn ms-3" onClick={handleMyWinCardClick}>
          {t("MY WINCARD")}
        </button>
      </div>
      <div className="win-incentive-header">
        <h2 className="account-snapshots-heading">{t('accountsnapshot')}</h2>
        <div className="account-snapshots-wrapper">
          <div className="account-snapshot-item">
            <p>{t('balance')} ${Balance}</p>
          </div>
          <div className="account-snapshot-item">
            <p>{t('totalearning')} ${Total}</p>
          </div>
          <div className="account-snapshot-item">
            <p>{t('redeemedrewards')} ${Redeemed}</p>
          </div>
        </div>
        <button className="redeem-my-rewards-btn" onClick={openModal}>
          {t('reedeemrewards')}
        </button>
      </div>

      <RedeemRewardsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        email={contractData.userData.EmailID} // Pass the user's email to the modal
        setEmail={setEmail}
        amount={Total}
        setAmount={setAmount}
        reloadHistory={fetchRewardsHistory} // Pass the reload function
      />

      <div className="row">
        <h3 className="page-heading-bold-primary-20">{t('earningandpayouthistoruy')}</h3>
        <div className="col-md-6 mt-5">
          {WINRewardsHistory &&
            WINRewardsHistory.map((entry, index) => (
              <div key={index} className="account-snapshot-history-item">
                <div className="account-snapshot-history-item-description">
                  <span className={`goal ${entry.RewardAmount.startsWith("-") ? "redeemed" : "" }`}>{entry.goal}</span>
                  <span
                    className={`amount ${
                      entry.RewardAmount.startsWith("-")
                        ? "redeemed"
                        : ""
                    }`}
                  >
                    {entry.RewardAmount.startsWith("-") ? "-" : "+"}${Math.abs(entry.RewardAmount)}
                  </span>
                </div>
                <span className="account-snapshot-history-item-time">{new Date(entry.timeofentry).toLocaleDateString()}</span>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default WinRewardsHistory;
